/* rescu-akb: Verhalten fuer die Seiten der Vlitex Akku Sicherheitsbox (08.10.2026).
   - Kaufbereich: Groessenwahl ohne Neuladen (Preise stehen als data-Attribute im
     Markup), Galerie springt zum Bild der Groesse, ?variant= in der Adresse.
   - Warenkorb per /cart/add.js mit Dawns Schublade; ohne Schublade zur Warenkorbseite.
   - Szenen und Groessenkarten waehlen die Groesse im Kaufbereich oder legen direkt ab.
   - Sticky-Leiste erscheint, sobald der Kaufknopf aus dem Bild ist.
   - Bewegung ist additiv: das Markup traegt den Endzustand, Klassen spielen nur ab. */
(function () {
  'use strict';
  if (window.__akb) return;
  window.__akb = true;

  var html = document.documentElement;
  html.classList.add('akb-js');
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var zahl = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(cent) { return zahl.format(cent / 100) + ' €'; }
  function brutto(cent) { return Math.round(cent * 1.19); }
  function int(w, e) { var n = parseInt(w, 10); return isNaN(n) ? e : n; }
  function alle(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* ---------- Zustand: gewaehlte Variante ---------- */

  var zustand = { id: null, preis: 0, groesse: '', modus: 'brutto' };
  function melden() {
    document.dispatchEvent(new CustomEvent('akb:variante', { detail: zustand }));
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(daten);
      } else {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__akbLabel) btn.__akbLabel = btn.innerHTML;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Wird hinzugefügt …';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.__akbLabel) btn.innerHTML = btn.__akbLabel;
    }
  }
  function knopfOk(btn) {
    if (!btn) return;
    btn.classList.add('ist-ok');
    btn.textContent = 'Im Warenkorb ✓';
    setTimeout(function () { btn.classList.remove('ist-ok'); knopfLaeuft(btn, false); }, 2200);
  }
  function ablegen(btn, items, fehlerEl) {
    if (fehlerEl) fehlerEl.hidden = true;
    knopfLaeuft(btn, true);
    return inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function (e) {
      knopfLaeuft(btn, false);
      if (fehlerEl) {
        fehlerEl.textContent = (e && e.message && e.message.length < 160) ? e.message : 'Das hat nicht geklappt. Bitte versuche es noch einmal.';
        fehlerEl.hidden = false;
      } else {
        window.alert('Das hat nicht geklappt. Bitte versuche es noch einmal.');
      }
    });
  }

  /* ---------- Galerie ---------- */

  function galerie(el) {
    var band = el.querySelector('[data-akb-band]');
    if (!band) return null;
    var bilder = alle('[data-akb-bild]', band);
    var punkte = alle('[data-akb-punkt]', el);
    var minis = alle('[data-akb-mini]', el);
    var aktuell = 0;

    function markieren(i) {
      aktuell = i;
      punkte.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      minis.forEach(function (m, k) { m.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function zeigen(i, sanft) {
      if (i < 0) i = bilder.length - 1;
      if (i >= bilder.length) i = 0;
      band.scrollTo({ left: bilder[i].offsetLeft - band.offsetLeft, behavior: (sanft && !ruhig) ? 'smooth' : 'auto' });
      markieren(i);
    }
    punkte.forEach(function (p, k) { p.addEventListener('click', function () { zeigen(k, true); }); });
    minis.forEach(function (m, k) { m.addEventListener('click', function () { zeigen(k, true); }); });
    var zur = el.querySelector('[data-akb-zurueck]');
    var vor = el.querySelector('[data-akb-vor]');
    if (zur) zur.addEventListener('click', function () { zeigen(aktuell - 1, true); });
    if (vor) vor.addEventListener('click', function () { zeigen(aktuell + 1, true); });
    band.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); zeigen(aktuell + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); zeigen(aktuell - 1, true); }
    });

    var warte;
    band.addEventListener('scroll', function () {
      clearTimeout(warte);
      warte = setTimeout(function () {
        var b = band.clientWidth || 1;
        var i = Math.round(band.scrollLeft / b);
        if (i !== aktuell && i >= 0 && i < bilder.length) markieren(i);
      }, 60);
    }, { passive: true });

    return {
      zuBild: function (nr) {
        for (var k = 0; k < bilder.length; k++) {
          if (bilder[k].getAttribute('data-akb-bild') === String(nr)) { zeigen(k, true); return; }
        }
      }
    };
  }

  /* ---------- Kaufbereich ---------- */

  var hauptKauf = null;

  function kaufbereich(sec) {
    var form = sec.querySelector('form[data-akb-form]');
    if (!form) return;
    var modus = sec.getAttribute('data-preis-modus') || 'brutto';
    var gal = galerie(sec);
    var radios = alle('input[data-akb-variante]', form);
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'id';
    form.insertBefore(hidden, form.firstChild);
    radios.forEach(function (r) { r.name = 'akb-wahl-' + sec.id; });

    var anzahl = form.querySelector('[data-akb-anzahl]');
    var submit = form.querySelector('[data-akb-submit]');
    var fehler = form.querySelector('[data-akb-fehler]');
    var preisEl = sec.querySelector('[data-akb-preis]');
    var zweitEl = sec.querySelector('[data-akb-preis-zweit]');

    function anwenden(r, quelle) {
      var cent = int(r.getAttribute('data-preis'), 0);
      hidden.value = r.value;
      var haupt = modus === 'brutto' ? brutto(cent) : cent;
      var zweit = modus === 'brutto' ? cent : brutto(cent);
      if (preisEl) preisEl.textContent = euro(haupt);
      if (zweitEl) zweitEl.textContent = euro(zweit);
      zustand = { id: r.value, preis: cent, groesse: r.getAttribute('data-groesse') || '', modus: modus };
      if (quelle !== 'start') {
        var bild = r.getAttribute('data-bild');
        if (gal && bild) gal.zuBild(bild);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', r.value);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { /* alte Browser: Adresse bleibt */ }
      }
      melden();
    }

    var start = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (start) { start.checked = true; anwenden(start, 'start'); }
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) anwenden(r); }); });

    var minus = form.querySelector('[data-akb-minus]');
    var plus = form.querySelector('[data-akb-plus]');
    if (minus && anzahl) minus.addEventListener('click', function () { anzahl.value = Math.max(1, int(anzahl.value, 1) - 1); });
    if (plus && anzahl) plus.addEventListener('click', function () { anzahl.value = Math.min(99, int(anzahl.value, 1) + 1); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!hidden.value) return;
      ablegen(submit, [{ id: int(hidden.value, 0), quantity: Math.max(1, int(anzahl && anzahl.value, 1)) }], fehler);
    });

    var api = {
      sec: sec,
      knopf: submit,
      waehlen: function (id) {
        var r = radios.filter(function (x) { return x.value === String(id); })[0];
        if (r && !r.checked) { r.checked = true; anwenden(r); }
      },
      ablegen: function (btn) {
        return ablegen(btn, [{ id: int(hidden.value, 0), quantity: Math.max(1, int(anzahl && anzahl.value, 1)) }], null);
      }
    };
    if (!hauptKauf) hauptKauf = api;
  }

  /* ---------- Szenen und Groessenkarten ---------- */

  function zumKauf() {
    if (!hauptKauf) return;
    var ziel = hauptKauf.sec;
    var top = ziel.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: top, behavior: ruhig ? 'auto' : 'smooth' });
  }

  function waehler() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-akb-waehle]');
      if (!btn) return;
      var id = btn.getAttribute('data-akb-waehle');
      if (btn.hasAttribute('data-akb-direkt')) {
        e.preventDefault();
        if (hauptKauf) hauptKauf.waehlen(id);
        ablegen(btn, [{ id: int(id, 0), quantity: 1 }], null);
        return;
      }
      if (!hauptKauf) return;
      e.preventDefault();
      hauptKauf.waehlen(id);
      zumKauf();
    });

    document.addEventListener('akb:variante', function (ev) {
      alle('[data-akb-fuer]').forEach(function (k) {
        k.classList.toggle('ist-gewaehlt', k.getAttribute('data-akb-fuer') === String(ev.detail.id));
      });
    });
  }

  /* ---------- Abschluss-Band ---------- */

  function band(sec) {
    var form = sec.querySelector('form[data-akb-bandform]');
    if (!form) return;
    var radios = alle('input[name="id"]', form);
    var knopf = form.querySelector('[data-akb-submit]');
    var fehler = form.querySelector('[data-akb-fehler]');
    var summe = form.querySelector('[data-akb-summe]');
    function zeigen() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r || !summe) return;
      var cent = int(r.getAttribute('data-preis'), 0);
      summe.textContent = 'inkl. 19 % MwSt. · ' + euro(cent) + ' netto · zzgl. Versand';
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        zeigen();
        if (hauptKauf) hauptKauf.waehlen(r.value);
      });
    });
    document.addEventListener('akb:variante', function (ev) {
      radios.forEach(function (r) { r.checked = (r.value === String(ev.detail.id)); });
      zeigen();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      ablegen(knopf, [{ id: int(r.value, 0), quantity: 1 }], fehler);
    });
    zeigen();
  }

  /* ---------- Sticky-Leiste ---------- */

  function sticky(el) {
    var knopf = el.querySelector('[data-akb-sticky-knopf]');
    var groesse = el.querySelector('[data-akb-sticky-groesse]');
    var preis = el.querySelector('[data-akb-sticky-preis]');
    var ab = int(el.getAttribute('data-ab'), 400);
    if (window.matchMedia('(max-width: 749px)').matches) ab = int(el.getAttribute('data-ab-mobil'), ab);

    document.addEventListener('akb:variante', function (ev) {
      var d = ev.detail;
      if (groesse) groesse.textContent = d.groesse;
      if (preis) preis.textContent = euro(d.modus === 'brutto' ? brutto(d.preis) : d.preis);
    });
    if (zustand.id) melden();

    var sperren = alle('[data-akb-sticky-aus]');
    var sichtbarSperre = 0;
    if (hatIO && sperren.length) {
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (en) { en.target.__akbSicht = en.isIntersecting; });
        sichtbarSperre = sperren.filter(function (s) { return s.__akbSicht; }).length;
        pruefen();
      });
      sperren.forEach(function (s) { io.observe(s); });
    }

    var an = false;
    function pruefen() {
      var hauptUnten = true;
      if (hauptKauf && hauptKauf.knopf) {
        var r = hauptKauf.knopf.getBoundingClientRect();
        hauptUnten = r.bottom < 0 || r.top > window.innerHeight;
      }
      var soll = window.pageYOffset >= ab && hauptUnten && sichtbarSperre === 0;
      if (soll === an) return;
      an = soll;
      el.classList.toggle('ist-sichtbar', an);
      el.setAttribute('aria-hidden', an ? 'false' : 'true');
      if (an) el.removeAttribute('inert'); else el.setAttribute('inert', '');
      html.classList.toggle('akb-sticky-an', an);
    }
    window.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen, { passive: true });
    pruefen();

    if (knopf) {
      knopf.addEventListener('click', function () {
        if (hauptKauf) hauptKauf.ablegen(knopf);
      });
    }
  }

  /* ---------- Bewegung ---------- */

  function bewegung() {
    if (ruhig || !hatIO) return;
    var ziele = alle('.akb-an, .akb-stapel');
    var hoehe = window.innerHeight;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('ist-da');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px', threshold: 0 });
    ziele.forEach(function (z) {
      // Was beim Laden schon sichtbar ist, bleibt ruhig stehen.
      if (z.getBoundingClientRect().top < hoehe) return;
      io.observe(z);
    });
  }

  /* ---------- Start ---------- */

  function start() {
    alle('[data-akb-kauf]').forEach(kaufbereich);
    alle('[data-akb-band-sec]').forEach(band);
    waehler();
    alle('[data-akb-sticky]').forEach(sticky);
    bewegung();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
